<template>

  <b-row>
    <b-col>
      <b-card 
        :style="onlyView? '' : isModalView"
        no-body 
        :class="{ 'open': visibleBody }"
      >
        <b-card-header 
          style="padding: 0 1px; color: black; font:45px; cursor: pointer;" 
          :class="{ 'collapsed': !visibleBody }"
          :aria-expanded="visibleBody ? 'true' : 'false'" 
          role="tab"
          data-toggle="collapse" 
          @click="onVisibleBody(!visibleBody)"
        >
          <span class="lead collapse-title">
            <strong>VALORACION NUTRICIONAL </strong>
          </span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse 
          v-model="visibleBody" 
          role="tabpanel"
        >
          <b-card-body >

            <fieldset :disabled="onlyView">

              <b-alert
                v-if="lastData"
                show class="p-2" variant="warning"
              >
                <div class="text-center">
                  <i class="fa-solid fa-lightbulb mx-1"/>
                  Se cargo informacion de los habitos de anterior evaluacion nutricional
                </div>
              </b-alert>

              <b-tabs active-nav-item-class="font-weight-bold text-uppercase text-success">
  
                <b-tab title="VALORACION ANTROPOMETRICA" active>
                  
                  <b-row class="mt-2 d-flex justify-content-start align-items-center">
  
                    <label class="offset-1 col-2">Edad:</label>
                    <b-form-input
                      class="col-2"
                      v-model="antropometrica.edad"
                      type="number" 
                      disabled
                    />
  
  
                    <label class="offset-1 col-2" for="">Talla (cm):</label>
                    <b-form-input
                      class="col-2"
                      v-model="antropometrica.talla"
                      type="number" 
                      disabled
                    />
  
  
                    <label class="offset-1 col-2">Peso (kg): </label>
                    <b-form-input 
                      class="col-2" 
                      type="number" 
                      v-model="antropometrica.peso"
                      disabled
                    />
  
                    <label class="offset-1 col-2">IMC: </label>
                    <b-form-input 
                      class="col-2"
                      type="number" 
                      v-model="antropometrica.imc"
                      disabled
                    />
  
                    <label class="offset-1 col-2" for="">Perimetro Abdominal(cm)</label>
                    <b-form-input 
                      class="col-2"
                      type="number" 
                      v-model="antropometrica.perimetroAbdominal"
                    />
                    
                  </b-row>
  
                  <hr class="my-3"/>

                  <b-row class="my-1">
                    <label class="ml-2 col-2">Edad metabolica:</label>

                    <InputNumber
                      v-model="antropometrica.edadMetabolica"
                      class="col-2"
                    />
                  </b-row>
  
                  <b-row class="d-flex justify-content-start align-items-center">
  
                    <label class="ml-2 col-2">Grasa abdominal:</label>
                    <b-form-input
                      class="col-2"
                      v-model="antropometrica.grasaAbdominal.value"
                      type="number" 
                    />
                    <v-select
                      v-model="antropometrica.grasaAbdominal.unit"
                      :options="['kg', '%']"
                      class="nutricional-select"
                      :disabled="onlyView"
                    />
  
                    
                    <label class="offset-1 col-2">Masa grasa:</label>
                    <b-form-input 
                      class="col-2" 
                      type="number" 
                      v-model="antropometrica.masaGrasa"
                    />
                    
  
                    <label class="ml-2 col-2 my-1" for="">Masa Grasa Corporal:</label>
                    <b-form-input
                      class="col-2"
                      v-model="antropometrica.grasaCorporal.value"
                      type="number" 
                    />
                    <v-select
                      v-model="antropometrica.grasaCorporal.unit"
                      :options="['kg', '%']"
                      class="nutricional-select"
                      :disabled="onlyView"
                    />
                    
  
                    <label class="offset-1 col-2">Masa muscular: </label>
                    <b-form-input 
                      class="col-2" 
                      type="number" 
                      v-model="antropometrica.masaMuscular"
                    />
  
  
                    <label class="ml-2 col-2">Grasa Visceral: </label>
                    <b-form-input 
                      class="col-2" 
                      type="number" 
                      v-model="antropometrica.grasaVisceral.value"
                    />
                    <v-select
                      v-model="antropometrica.grasaVisceral.unit"
                      :options="['kg', '%']"
                      class="nutricional-select"
                      :disabled="onlyView"
                    />
  
                    
                    <label class="offset-1 col-2">Tasa Metabolica Basal (kcal): </label>
                    <b-form-input 
                      class="col-2" 
                      type="number" 
                      v-model="antropometrica.basal"
                    />
  
                    
                  </b-row>
                </b-tab>
  
  
                <b-tab title="HABITOS">
                  <div class="mx-2">
  
                    <b-row class="my-2 align-items-center">
                      <label class="col-2">Sueño:</label>
                      <b-form-input v-model="habitos.sueno" class="col"/>
                    </b-row>
    
                    <b-row class="my-2 align-items-center">
                      <label class="col-2">Consumo agua:</label>
                      <b-form-input v-model="habitos.agua" class="col"/>
                    </b-row>
    
                    <b-row class="my-2 align-items-center">
                      <label class="col-2">Consume café:</label>
    
                      <b-form-checkbox
                        class="col-2"
                        v-model="habitos.cafe.active"
                        name="check-button"
                        switch
                      >
                        <label for="">{{ habitos.cafe.active ? " Sí" : " No" }}</label>
                      </b-form-checkbox>
    
                      <b-form-input 
                        v-if="habitos.cafe.active"
                        v-model="habitos.cafe.descripcion"
                        class="col"
                      />
                    </b-row>
                    
                    <b-row class="my-2 align-items-center">
                      <label class="col-2">Alcohol:</label>
    
                      <b-form-checkbox
                        class="col-2"
                        v-model="habitos.alcohol.active"
                        name="check-button"
                        switch
                      >
                        <label for="">{{ habitos.alcohol.active ? " Sí" : " No" }}</label>
                      </b-form-checkbox>
    
                      <b-form-input
                        v-if="habitos.alcohol.active"
                        v-model="habitos.alcohol.descripcion"
                        class="col"
                      />
                    </b-row>
    
                    <b-row class="my-2 align-items-center">
                      <label class="col-2">Fuma:</label>
    
                      <b-form-checkbox
                        class="col-2"
                        v-model="habitos.fuma.active"
                        name="check-button"
                        switch
                      >
                        <label for="">{{ habitos.fuma.active ? " Sí" : " No" }}</label>
                      </b-form-checkbox>
    
                      <b-form-input 
                        v-if="habitos.fuma.active"
                        v-model="habitos.fuma.descripcion"
                        class="col"
                      />
                    </b-row>
    
                    <b-row class="my-2 align-items-center">
                      <label class="col-2">Drogas:</label>
    
                      <b-form-checkbox
                        class="col-2"
                        v-model="habitos.drogas.active"
                        name="check-button"
                        switch
                      >
                        <label for="">{{ habitos.drogas.active ? " Sí" : " No" }}</label>
                      </b-form-checkbox>
    
                      <b-form-input
                        v-if="habitos.drogas.active"
                        v-model="habitos.drogas.descripcion"
                        class="col"
                      />
                    </b-row>
    
    
                    <b-row class="my-2 align-items-center">
                      <label class="col-2">Suplementacion:</label>
    
                      <b-form-checkbox
                        class="col-2"
                        v-model="habitos.medicacion.active"
                        name="check-button"
                        switch
                      >
                        <label for="">{{ habitos.medicacion.active ? " Sí" : " No" }}</label>
                      </b-form-checkbox>
    
                      <b-form-input 
                        v-if="habitos.medicacion.active"
                        v-model="habitos.medicacion.descripcion"
                        class="col"
                      />
                    </b-row>
    
                    
                    <b-row class="my-2 align-items-center">
                      <label class="col-2">Actividad fisica:</label>
    
                      <b-form-checkbox
                        class="col-2"
                        v-model="habitos.actividadFisica.active"
                        name="check-button"
                        switch
                      >
                        <label for="">{{ habitos.actividadFisica.active ? " Sí" : " No" }}</label>
                      </b-form-checkbox>
    
                      <b-form-input
                        v-if="habitos.actividadFisica.active"
                        v-model="habitos.actividadFisica.descripcion"
                        class="col"
                      />
                    </b-row>
    
    
                    <b-row class="my-2 align-items-center">
                      <label class="col-2">Tipo actividad laboral:</label>
    
                      <v-select 
                        v-model="habitos.laboral.tipo"
                        class="col-3"
                        :options="actividadLaboralOpts"
                        :disabled="onlyView"
                      />
                      <b-form-input
                        v-if="habitos.laboral.tipo"
                        v-model="habitos.laboral.descripcion"
                        class="col"
                      />
                    </b-row>
    
                    <hr>
    
                    <b-row class="my-2 align-items-center">
                      <label class="col-2">Estados emocionales:</label>
    
                      <v-select 
                        v-model="habitos.trastornos.selecteds"
                        class="col-3"
                        :options="trastornosOpts"
                        multiple
                        :disabled="onlyView"
                        taggable
                      />
                      <b-form-input
                        v-if="habitos.trastornos.selecteds.length"
                        v-model="habitos.trastornos.descripcion"
                        class="col"
                      />
                    </b-row>
                  </div>
  
                </b-tab>
  
  
                <!-- <b-tab title="PRESCRIPCION DIETETICA">
                  <div class="mx-2">
  
                    <b-row class="my-2 align-items-center">
                      <label class="col-2">Prescripcion:</label>
  
                      <b-form-textarea
                        v-model="prescripcion.prescripcion"
                        class="col-12 mx-1"
                        rows="4"
                      />
                    </b-row>
                  </div>  
                </b-tab> -->
              </b-tabs>
            </fieldset>
            <div class="text-right">
              <b-button 
                v-if="!onlyView" 
                @click="copyAS400()" 
                variant="info"
              >
                AS400 <i class="fas fa-copy" />
              </b-button>
            </div>
          </b-card-body>
            
        </b-collapse>
      </b-card>
    </b-col>
  </b-row>
  
</template>

<script>
import { mapState } from "vuex";
import vSelect      from 'vue-select';
import { signosVitalesService } from "@/views/signosVitales/services";
import { ESPECIALIDAD } from "@/shared/constants";
import { copyText } from "@/shared/helpers";
import { InputNumber } from "@/shared/components";

export default {

  name: "SemiologiaNutricional",

  props: {
    onlyView: {
      type: Boolean,
      default: false
    },

    dataSaved: {
      type: Object,
      default: null
    },

    lastData: {
      type: Object,
      default: null
    }
  },

  components: {
    vSelect,
    InputNumber
  },


  created() {
    if(!this.dataSaved && !this.onlyView) this.loadDataSignos();
  },

  data() {
    return {

      visibleBody: true,

      antropometrica: {
        edad  : null,
        talla : null,
        peso  : null,
        imc   : null,
        perimetroAbdominal : null,

        edadMetabolica : null,
        grasaAbdominal   : { value: null, unit: null },
        grasaCorporal    : { value: null, unit: null },
        grasaVisceral    : { value: null, unit: null },
        masaGrasa     : null,
        masaMuscular  : null,
        basal         : null,
      },

      habitos: {
        sueno: null,
        agua: null,
        cafe: {
          active: false,
          descripcion: null
        },

        alcohol:{
          active: false,
          descripcion: null
        },

        fuma:{
          active: false,
          descripcion: null,
        },

        drogas:{
          active: false,
          descripcion: null
        },

        medicacion:{
          active: false,
          descripcion: null
        },

        actividadFisica:{
          active: false,
          descripcion: null
        },

        laboral:{
          tipo: null,
          descripcion: null
        },

        trastornos:{
          selecteds: [],
          descripcion: null
        }
      },

      // prescripcion:{
      //   prescripcion: null
      // },
      

      actividadLaboralOpts: [
        "Sedentaria", "Poco activa", "Activa", "Muy activa"
      ],

      trastornosOpts: [
        "Ansiedad", "Depresion", "Estres"
      ]

    };
  },
  methods: {
    onVisibleBody(value) {
      this.visibleBody = value;
    },


    async loadDataSignos() {

      const tokenCita = this.stTokenCita;
      const responseSignos = await signosVitalesService.getByCita(tokenCita);

      if(!responseSignos){
        console.error("No se encontraron signos vitales, para sem nutricional");
        return;
      }
      
      this.antropometrica.edad  = this.stEdad;
      this.antropometrica.talla = responseSignos.talla;
      this.antropometrica.peso  = responseSignos.peso;
      this.antropometrica.imc   = responseSignos.imc;
      this.antropometrica.perimetroAbdominal = responseSignos.perimetroAbdominal;
    },


    copyAS400() {
      
      let text = '';

      if(this.nutricional){
        
        const { antropometrica, habitos, prescripcion } = this.nutricional;

        const antropometricaText = [];
        const habitosText        = [];
        // const prescripcionText   = [];


        if(antropometrica.edad)  antropometricaText.push(`Edad: ${antropometrica.edad}`);
        if(antropometrica.talla) antropometricaText.push(`Talla(cm): ${antropometrica.talla}`);
        if(antropometrica.peso)  antropometricaText.push(`Peso(kg): ${antropometrica.peso}`);
        if(antropometrica.imc)   antropometricaText.push(`IMC: ${antropometrica.imc}`);
        if(antropometrica.perimetroAbdominal)    antropometricaText.push(`Perimetro abdominal(cm): ${antropometrica.perimetroAbdominal}`);
        if(antropometrica.edadMetabolica)        antropometricaText.push(`Edad metabolica: ${antropometrica.edadMetabolica}`);
        if(antropometrica.grasaAbdominal.value ) antropometricaText.push(`Grasa abdominal: ${antropometrica.grasaAbdominal.value} ${antropometrica.grasaAbdominal.unit || ""}`);
        if(antropometrica.grasaCorporal.value  ) antropometricaText.push(`Masa grasa corporal: ${antropometrica.grasaCorporal.value} ${antropometrica.grasaCorporal.unit || ""}`);
        if(antropometrica.grasaVisceral.value  ) antropometricaText.push(`Grasa visceral: ${antropometrica.grasaVisceral.value} ${antropometrica.grasaVisceral.unit || ""}`);
        if(antropometrica.masaGrasa)             antropometricaText.push(`Masa grasa: ${antropometrica.masaGrasa}`);
        if(antropometrica.masaMuscular)          antropometricaText.push(`Masa muscular: ${antropometrica.masaMuscular}`);
        if(antropometrica.basal)                 antropometricaText.push(`Tasa Metabolica Basal (kcal): ${antropometrica.basal}`);

        habitosText.push(`Sueño: ${habitos.sueno || "Sin informacion"}`);
        habitosText.push(`Consumo de agua: ${habitos.agua || "Sin informacion"}`);
        habitosText.push(`Consumo de cafe: ${habitos.cafe.active ? "(Si)" : "No"} ${habitos.cafe.descripcion || ""}`);
        habitosText.push(`Consumo de alcohol: ${habitos.alcohol.active ? "(Si)" : "No"} ${habitos.alcohol.descripcion || ""}`);
        habitosText.push(`Consumo de fuma: ${habitos.fuma.active ? "(Si)" : "No"} ${habitos.fuma.descripcion || ""}`);
        habitosText.push(`Consumo de drogas: ${habitos.drogas.active ? "(Si)" : "No"} ${habitos.drogas.descripcion || ""}`);
        habitosText.push(`Consumo de suplementos: ${habitos.medicacion.active ? "(Si)" : "No"} ${habitos.medicacion.descripcion || ""}`);
        habitosText.push(`Actividad fisica: ${habitos.actividadFisica.active ? "(Si)" : "No"} ${habitos.actividadFisica.descripcion || ""}`);
        if(habitos.laboral.tipo)            habitosText.push(`Actividad laboral: ${habitos.laboral.tipo} ${habitos.laboral.descripcion || ""}`);
        if(habitos.trastornos.selecteds.length) habitosText.push(`Estados Emocionales: (${habitos.trastornos.selecteds.join(", ")}) ${habitos.trastornos.descripcion}`);

        // if(prescripcion.prescripcion) prescripcionText.push(`${prescripcion.prescripcion}`);

        text = `Evaluación Nutricional:
  ${antropometricaText.length ? '* Antropometrica:' : ''}
${antropometricaText.length ? antropometricaText.map( i => `    - ${i}\n`).join("") : ''}
  ${habitosText.length ? '* Habitos:' : ''}
${habitosText.length ? habitosText.map( i => `    - ${i}\n`).join("") : ''}
        `
      }

      copyText(text);

      this.$bvToast.toast('El texto ha sido copiado', {
        title: `Copiado`,
        variant: 'success',
      })
    }

  },

  computed: {

    ...mapState({
      stEdad       : state => state.atencionCita.dataCita?.paciente?.persona.edad,
      stTalla      : state => state.atencionCita.signosVitales?.currentSignos.talla,
      stDataDoctor : state => state.atencionCita.dataCita?.doctor,

      stTokenCita   : state => state.atencionCita.dataCita.token,
      stSemiologiaView: state => state.atencionMedica.dataAtencion.semiologiaView
    }),


    isModalView() {
      return {
        margin: '0',
        border: '1px solid #2980b9',
        padding: '0 10px'

      }
    },

    nutricional() {
      return {
        antropometrica: this.antropometrica,
        habitos       : this.habitos,
        // prescripcion  : this.prescripcion,
      };
    },

    esCitaNutricion(){
      return this.stDataDoctor?.especialidad?.codEsp === ESPECIALIDAD.NUTRICION;
    },

  },


  watch: {

    nutricional:{
      deep: true,
      handler( newValue ){
        if(!this.esCitaNutricion) return;

        this.$store.commit("setSemNutricional", newValue);

        const data = {
          tipo: 'nutricional',
          data: newValue
        }

        this.$store.commit("setSemActual", data);
      },
    },


    dataSaved: {
      deep: true,
      immediate: true,
      handler(newValue) {

        if(this.onlyView) return;

        if (newValue) {
          if(newValue.antropometrica) this.antropometrica = newValue.antropometrica;
          if(newValue.habitos)        this.habitos        = newValue.habitos;
          // if(newValue.prescripcion)   this.prescripcion   = newValue.prescripcion;
        }
      }
    },


    lastData: {
      deep: true,
      immediate: true,
      handler(newValue) {

        if(this.onlyView ) return;
        if (newValue) {
          if(newValue.habitos) this.habitos = newValue.habitos;
        }

      }
    },


    stSemiologiaView:{
      immediate: true,
      handler(newValue){

        if(!this.onlyView) return;

        if(newValue.antropometrica) this.antropometrica = newValue.antropometrica;
        if(newValue.habitos)        this.habitos        = newValue.habitos;
        // if(newValue.prescripcion)   this.prescripcion   = newValue.prescripcion;
        
      }
    },
  }
  
};
</script>

<style scoped>
.nutricional-label{
  width: 100px;
}

.nutricional-select{
  width: 105px;
}
</style>